import MultiSelectComponent from "../../../components/multi-select/multi-select.component";
import paginationComponent from "../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import SelectSiteGroupComponent from "../../../components/site/select-site-group.component";
import SelectSiteComponent from "../../../components/site/select-site.component";
import { codeMasterType } from "../../../config/constants";
import codeMasterModel from "../../../models/common/code-master.model";
import GscmDivisionModel from "../../../models/gscm-division/gscm-division.model";
import loginModel from "../../../models/login.model";
import SiteSoldToShipToSpecialModel from "../../../models/site-management/site-sold-to-ship-to-special.model";
import ViewBase from "../../view-base.view";
import SiteSoldToShipToSpecialUploadDialog from "./site-sold-to-ship-to-special.excel-upload.dialog";
import SiteSoldToShipToSpecialUpdateDialog from "./site-sold-to-ship-to-special.update.dialog";
import { downloadUserFileByFileID } from "../../../models/file.model"
import moment from "moment";
import { formats } from "../../../config/constants";

/**
 * Site Sold To Ship To Special Mapping View
 * 
 * A page that displays a list of Site Sold To Ship To Special Mapping
 * 
 * @author cmcnkhiep
 */

export default function SiteSpecialMapping() {
    
    ViewBase.call(this);
    
    const SELECT_ALL_CHECKBOX_ID = 'specialSoldToShipToSelectAllCheckbox';
    const CHECKBOX_NAME = 'specialSoldToShipToCheckbox';

    const countryCode = loginModel.credentials.country

    const DEFAULT_SELECTED_ITEM = { repSoldToCode: '' }

    const SOLD_TO_OPTIONS = [
      { code: "all", name: "All" },
      { code: "One", name: "One Sold-To" },
      { code: "Many", name: "Multi Sold-To" },
    ];

    const DATASOURCE_OPTIONS = [
      { code: "all", name: "All" },
      { code: "GSCM", name: "GSCM" },
      { code: "MCS", name: "MCS" },
    ];

    const DEFAULT_FILTERS = {
        siteIDs: [],
        gscmDivisions: [],
        siteGroups: [],
        statusCodes: [],
        imceStores: [],
        oneOrMultiSoldTo: SOLD_TO_OPTIONS[0],
        dataSource: DATASOURCE_OPTIONS[0],
        showOnlyEmptyRepSoldto: false,
        isExcelDownload: false
    };

    const DEFAULT_PAGINATION = {
        pageSize: 10,
        pageIndex: 1,
        totalItems: 0
    };

    let filters = structuredClone(DEFAULT_FILTERS);
    let currentFilters = structuredClone(DEFAULT_FILTERS)
    let pagination = structuredClone(DEFAULT_PAGINATION);
    let selectedUpdateItem = structuredClone(DEFAULT_SELECTED_ITEM);

    let gscmDivisionOptions = []
    let storeStatusOptions = []
    let imceTypeChoicesOptions = []

    let siteSpecialMappingList = [];
    let selectedSiteSpecialMapping = [];
    let isUpdateDialogOpen = false;
    let isExcelUploadOpen = false;

    const toQueryParams = (params) => {
        return Object.assign(
            {
                pageSize: pagination.pageSize,
                pageIndex: pagination.pageIndex,
                siteIDs: params.siteIDs.map(({ code }) => code),
                gscmDivisions: params.gscmDivisions.map(({ code }) => code),
                siteGroups: params.siteGroups.map(({ code }) => code),
                statusCodes: params.statusCodes.map(({ code }) => code),
                imceStores: params.imceStores.map(({ code }) => code),
                oneOrMultiSoldTo: params.oneOrMultiSoldTo.code === 'all' ? '' : params.oneOrMultiSoldTo.code,
                dataSource: params.dataSource.code === 'all' ? '' : params.dataSource.code,
                showOnlyEmptyRepSoldto: params.showOnlyEmptyRepSoldto,
                isExcelDownload: params.isExcelDownload
            },
        );
    };
    
    const clearFilter = () => {
        filters = structuredClone(DEFAULT_FILTERS);
    };

    const onCheckAll = (event) => {
        let checkboxes = document.querySelectorAll(`input[type='checkbox'][name='${CHECKBOX_NAME}']`);
    
        selectedSiteSpecialMapping = [];

        if (event.target.checked || event.target.indeterminate) {
            siteSpecialMappingList.forEach((item) => {
                selectedSiteSpecialMapping.push(item);
            });

            checkboxes.forEach((item) => {
                item.checked = true;
            });
        } else {
            checkboxes.forEach((item) => {
                item.checked = false;
            });
        }
        event.target.indeterminate = false;
    };

    const selectRow = (checked, item) => {
        if (checked) {
            selectedSiteSpecialMapping.push(item);
        } else {
            selectedSiteSpecialMapping = selectedSiteSpecialMapping.filter((data) => data.siteID !== item.siteID || data.gscmDivision !== item.gscmDivision);
        }

        let selectAllCheckbox = document.querySelector(`#${SELECT_ALL_CHECKBOX_ID}`);
        if (selectedSiteSpecialMapping.length === 0) {
            selectAllCheckbox.indeterminate = false;
            selectAllCheckbox.checked = false;
        }
        else if (selectedSiteSpecialMapping.length === siteSpecialMappingList.length) {
            selectAllCheckbox.indeterminate = false;
            selectAllCheckbox.checked = true;
        } else {
            selectAllCheckbox.indeterminate = true;
            selectAllCheckbox.checked = false;
        }
    };

    const uncheckAllCheckboxes = () => {
        const checboxes = document.querySelectorAll(`input[name=${CHECKBOX_NAME}]`);
        if(checboxes.length == 0) {
            return;
        }
        checboxes.forEach((checkbox) => {
            checkbox.checked = false;
        })
        let selectAllCheckbox = document.querySelector(`#${SELECT_ALL_CHECKBOX_ID}`);
        selectAllCheckbox.indeterminate = false;
        selectAllCheckbox.checked = false;

        selectedSiteSpecialMapping = [];
    }

    const hasChanges = () => {
        if (siteSpecialMappingList.length === 0) {
            return false;
        }

        return siteSpecialMappingList.some((e) => e.initialApprovedQty !== e.approvedQty);
    };

    const leavePageEventListener = (e) => {
        if (hasChanges() && !confirm(this.getText('EM00000776', 'Changes you made may not be saved'))) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    };

    const getGscmDivisionOptions = () => {
        GscmDivisionModel.getGscmDivisions()
            .then((result) => {
                if (result?.length > 0) {
                    gscmDivisionOptions = result
                }
            })
            .catch((error) => {
                this.handleError(error);
            });
    };

    const getStoreStatusOptions = () => {
        codeMasterModel.getByCategoryV2({ category: codeMasterType.siteStatus})
            .then((result) => {
                if (result?.length > 0) {
                    storeStatusOptions = result
                }
            })
            .catch((error) => {
                this.handleError(error);
            });
    };

    const getImceTypeChoiceOptions = () => {
        codeMasterModel.getByCategoryV2({ category: codeMasterType.imceTypeChoice})
            .then((result) => {
                if (result?.length > 0) {
                    imceTypeChoicesOptions = result
                }
            })
            .catch((error) => {
                this.handleError(error);
            });
    };

    const getSiteSpecialMapping = () => {
        currentFilters.isExcelDownload = false;
        this.showLoading();
        uncheckAllCheckboxes();
        SiteSoldToShipToSpecialModel.searchSiteSpecialMapping(toQueryParams(currentFilters)).then((result) => {
            siteSpecialMappingList = result.data;
            pagination.pageIndex = result.pageIndex;
            pagination.pageSize = result.pageSize;
            pagination.totalItems = result.total;
            
        }).catch((error) => {
            this.handleError(error);
        }).finally(() => {
            this.hideLoading();
        })
    }

    const downloadSiteSpecialMap = () => {
        currentFilters.isExcelDownload = true;
        this.showLoading();
        SiteSoldToShipToSpecialModel.downloadSiteSpecialMappingExcel(toQueryParams(currentFilters)).catch((error) => {
            this.handleError(error);
        }).finally(() =>  {
            this.hideLoading();
        })
    }

    const handleDeleteSiteSpecialMappingItems = () => {
        if (!selectedSiteSpecialMapping.length) {
            this.showErrorMessage(this.getText("LT00000719", "No items selected"));
            return;
        }
        const formatedData = selectedSiteSpecialMapping.map(
            ({ siteID, gscmDivision, repSoldToCode }) => ({
                siteId: siteID,
                gscmDivision,
                representativeSoldToCode: repSoldToCode,
            })
        );
        this.showConfirm(this.getText('EM00000265', 'Are you sure you want to delete?'), '', (e) => {
            if(e == 'YES') {
                SiteSoldToShipToSpecialModel.deleteSiteSpecialMapping(formatedData)
                .then((result) => {
                    if(result.success > 0) getSiteSpecialMapping();
                    this.showConfirm(
                        `${this.getText('EM00000004', 'Success')}: ${result.success}, ${this.getText('LT00000829', 'Failure')}: ${result.failure}`,
                        this.getText('LT00000828', 'Do you want to download result file?'),
                        (e) => {
                            if(e == "YES") {
                                const fileName = `DeleteResultRepSoldToMapping_${moment().format(formats.apiDateFormat)}`
                                downloadUserFileByFileID(result.fileId, fileName);
                            }
                        }
                    );
                })
                .catch((error) => {
                    this.handleError(error);
                })
            }
        });
    };

    return {
        oninit: () => {
            getGscmDivisionOptions();
            getStoreStatusOptions();
            getImceTypeChoiceOptions();
            getSiteSpecialMapping();
        },
        oncreate: () => {
            addEventListener('route', leavePageEventListener);
            addEventListener('beforeunload', leavePageEventListener);
        },
        onremove: () => {
            removeEventListener('route', leavePageEventListener);
            removeEventListener('beforeunload', leavePageEventListener);
        },
        view: () => {
            return [
                /* SEARCH */
                m('.card.mb-3',
                    m('.card-body',
                        m('form',{
                            onsubmit: (e) => {
                                e.preventDefault();
                                currentFilters = structuredClone(filters);
                                pagination = structuredClone(DEFAULT_PAGINATION);
                                getSiteSpecialMapping();
                            }
                        },
                            m('.row.g-2',
                                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                                    m('label.form-label[for=site]', this.getText("LT00000516", "Site(s)")),
                                    m(SelectSiteComponent, {
                                        id: "site",
                                        class: "form-control",
                                        filters: { coutryCode: countryCode },
                                        selectedItemList: filters.siteIDs,
                                        onChange: (selectedItems) => {
                                            filters.siteIDs = selectedItems
                                        }
                                    }),
                                ),
                                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                                    m('label.form-label[for=gmcsDiv]', this.getText('LT00000814', 'GSCM Division(s)')),
                                    m(MultiSelectComponent, {
                                        id: "gmcsDiv",
                                        class: "form-control",
                                        items: gscmDivisionOptions,
                                        selectedItems: filters.gscmDivisions,
                                        onSelect: (selectedItems) => {
                                            filters.gscmDivisions = selectedItems;
                                        },
                                    })
                                ),
                                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                                    m('label.form-label[for=gmcsGroup]', this.getText('LT00000815', 'GSCM Site Group(s)')),
                                    m(SelectSiteGroupComponent, {
                                        id: "gmcsGroup",
                                        filters: { countryCode: countryCode },
                                        selectedItems: filters.siteGroups,
                                        onChange: (selectedItems) => {
                                        filters.siteGroups = selectedItems;
                                        }
                                    }),
                                    
                                ),
                                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                                    m('label.form-label[for=gmcsStatus]', this.getText('LT00000816', 'GSCM Site Status(s)')),
                                    m(MultiSelectComponent, {
                                        id: "gmcsStatus",
                                        class: "form-control",
                                        items: storeStatusOptions,
                                        selectedItems: filters.statusCodes,
                                        onSelect: (selectedItems) => {
                                            filters.statusCodes = selectedItems;
                                        },
                                    })
                                ),
                                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                                    m('label.form-label[for=imceStore]', this.getText('LT00000817', 'IM/CE Store')),
                                    m(MultiSelectComponent, {
                                        id: "imceStore",
                                        class: "form-control",  
                                        items: imceTypeChoicesOptions, 
                                        selectedItems: filters.imceStores,
                                        onSelect: (selectedItems) => {
                                            filters.imceStores = selectedItems;
                                        },
                                    })
                                ),
                                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                                    m('label.form-label[for=oneOrMulti]', this.getText('LT00000818', '1 Sold-To or Multi Sold-To')),
                                    m(SingleSelectComponent, {
                                        id: "oneOrMulti",
                                        class: "form-control",
                                        items: SOLD_TO_OPTIONS,
                                        selectedItem: filters.oneOrMultiSoldTo,
                                        onSelect: (selectedItem) => { 
                                            filters.oneOrMultiSoldTo = selectedItem
                                        }
                                    })
                                ),
                                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                                    m('label.form-label[for=dataSource]', this.getText('LT00000819', 'Data Source for Sold-To/Ship-To')),
                                    m(SingleSelectComponent, {
                                        id: "dataSource",
                                        class: "form-control",
                                        items: DATASOURCE_OPTIONS,
                                        selectedItem: filters.dataSource,
                                        onSelect: (selectedItem) => { 
                                            filters.dataSource = selectedItem 
                                        }
                                    })
                                ),
                                m('.col-xl-3.col-lg-4.col-sm-6.position-relative.d-flex.align-items-center',
                                    m('input#showEmptyRepSoldTo.form-check-input.me-2[type="checkbox"]', {
                                        checked: filters.showOnlyEmptyRepSoldto,
                                        onchange: (e) => {
                                            filters.showOnlyEmptyRepSoldto = e.target.checked;
                                        }
                                    },),
                                    m('label.form-check-label[for="showEmptyRepSoldTo"]', this.getText('LT00000820', 'Show Only Empty Representative Sold-To'))
                                ),
                                m('.col-12.d-flex.justify-content-end.gap-2',
                                    m('button.btn.btn-primary',
                                        {   
                                            type: 'submit',
                                        },
                                        this.getText("LT00000001", "Search")
                                    ),
                                    m('button.btn.btn-white',
                                        {
                                            type: 'button',
                                            onclick: () => {
                                                clearFilter();
                                            }
                                        },
                                        this.getText("LT00000031", "Clear")
                                    )
                                )
                            )
                        ),
                        
                    )
                ),

                /* TABLE */
                m('.card',
                    m('.card-body',
                        m('.row.g-2',
                            m('.col-12.d-flex.justify-content-between',
                                m('.d-flex.gap-2',
                                    m('button.btn.btn-danger', 
                                        { 
                                            onclick: handleDeleteSiteSpecialMappingItems 
                                        }, 
                                        this.getText('LT00000821', 'Delete Selected')
                                    )
                                ),
                                m('.d-flex.gap-2',
                                    m('button.btn.btn-primary', 
                                        { 
                                            onclick: () => { isExcelUploadOpen = true; } 
                                        },
                                        m('i.bi.bi-file-earmark-arrow-up-fill'),
                                        this.getText('LT00000197', 'Excel Upload')
                                    ),
                                    m('button.btn.btn-primary', 
                                        { 
                                            onclick: downloadSiteSpecialMap 
                                        }, 
                                        m('i.bi.bi-file-earmark-arrow-down-fill'), 
                                        this.getText('LT00000018', 'Excel Download')
                                    )
                                )
                            ),
                            m('.col-12',
                                m('.table-responsive',
                                    m('table.table.table-hover.sticky-column-start',
                                        m('thead',
                                            m('tr.align-middle',
                                                m('th[scope="col"]',
                                                    m('input', {
                                                        tabindex: -1,
                                                        id: SELECT_ALL_CHECKBOX_ID,
                                                        type: 'checkbox',
                                                        onchange: onCheckAll
                                                    })
                                                ),
                                                m('th[scope="col"]', this.getText('LT00000817', 'IM/CE Store')),
                                                m('th[scope="col"]', this.getText('LT00000809', 'Site ID')),
                                                m('th[scope="col"]', this.getText('LT00000144', 'Site Name')),
                                                m('th[scope="col"]', this.getText('LT00000241', 'GSCM Division')),
                                                m('th[scope="col"]', this.getText('LT00000822', '# of Sold-To Codes')),
                                                m('th[scope="col"]', this.getText('LT00000823', 'Representative Sold-To Code'),),
                                                m('th[scope="col"]', this.getText('LT00000824', 'Representative Sold-To Name'),),
                                                m('th[scope="col"]', this.getText('LT00000081', 'Create User')),
                                                m('th[scope="col"]', this.getText('LT00000041', 'Create Date')),
                                                m('th[scope="col"]', this.getText('LT00000305', 'Update User')),
                                                m('th[scope="col"]', this.getText('LT00000306', 'Update Date')),
                                                m('th[scope="col"]', this.getText('LT00000092', 'Action')),
                                            )
                                        ),
                                        m('tbody',
                                            (siteSpecialMappingList.length == 0) &&
                                            m('tr.align-middle',
                                                m('td[colSpan=13]', this.getText("EM00000141", "No records found."))
                                            ),
                                            siteSpecialMappingList.length > 0 &&
                                            siteSpecialMappingList.map((data, index) =>
                                                m('tr.align-middle',
                                                    m('td',
                                                        m('input', {
                                                            id: `${CHECKBOX_NAME}${index}`,
                                                            type: 'checkbox',
                                                            tabindex: -1,
                                                            name: CHECKBOX_NAME,
                                                            onchange: (event) => { selectRow(event.target.checked, data); }
                                                        })
                                                    ),
                                                    m('td', m('span.cursor-text', data.imceStore)),
                                                    m('td', m('span.cursor-text', data.siteID)),
                                                    m('td', m('span.cursor-text', data.siteName)),
                                                    m('td', m('span.cursor-text', data.gscmDivision)),
                                                    m('td', m('span.cursor-text', data.soldToCount)),
                                                    m('td', m('span.cursor-text', data.repSoldToCode)),
                                                    m('td', m('span.cursor-text', data.repSoldToName)),
                                                    m('td', m('span.cursor-text', data.createUserId)),
                                                    m('td', m('span.cursor-text', data.createDate)),
                                                    m('td', m('span.cursor-text', data.updateUserId)),
                                                    m('td', m('span.cursor-text', data.updateDate)),
                                                    m("td.center",
                                                        m('i.bi.bi-pencil-square.list-action-icon[title="Edit"]', {
                                                            onclick: () => { 
                                                                selectedUpdateItem = data
                                                                isUpdateDialogOpen = true;
                                                            } 
                                                        })
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            m('.col-12', m(paginationComponent,
                                {
                                    currentPage: pagination.pageIndex,
                                    pageSize: pagination.pageSize,
                                    totalItems: pagination.totalItems,
                                    onPageChanged: (pageIndex) => {
                                        pagination.pageIndex = pageIndex;
                                        getSiteSpecialMapping();
                                    },
                                    onPageSizeChanged: (pageIndex, pageSize) => {
                                        pagination.pageSize = pageSize;
                                        pagination.pageIndex = pageIndex;
                                        getSiteSpecialMapping();
                                    }
                                }
                            )),
                        )
                    )
                ),

                /* UPDATE REPRESENTATIVE SOLD-TO DIALOG */

                m(SiteSoldToShipToSpecialUpdateDialog,
                    {
                        updateItem: selectedUpdateItem,
                        isOpen: isUpdateDialogOpen,
                        onClose: (reload) => { 
                            if(reload === true) {
                                getSiteSpecialMapping();
                            }
                            isUpdateDialogOpen = false;
                        },
                    }
                ),

                /* EXCEL UPLOAD DIALOG */
                m(SiteSoldToShipToSpecialUploadDialog,
                    {
                        filters,
                        isOpen: isExcelUploadOpen,
                        onClose: (reload) => { 
                            if(reload === true) {
                                getSiteSpecialMapping();
                            }
                            isExcelUploadOpen = false; 
                        }
                    }
                ),
                this.getBaseViews()
            ];
        }
    };
}
